import Swiper, { Navigation, Pagination, EffectFade, } from '../../node_modules/swiper/swiper-bundle.min.js';

Swiper.use([Navigation, Pagination, EffectFade,]);

document.addEventListener("DOMContentLoaded", () => {

	const cardSwiper = new Swiper('.cardSwiper', {

        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 16,

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
         
          1024: {
            slidesPerView: 3,
            spaceBetween: 16,
          },

          1280: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
        },
    });
});